import React from 'react';
import { useIntl } from 'react-intl';
import VolumetricModularImg from '../images/special-products.png';
import Icons from '../../../components/Icons/Icons';
import css from './Sections.module.css';

function SectionsSpecialProducts() {
  const intl = useIntl();

  return (
    <div className={css.specialProductSections}>
      <h2>{intl.formatMessage({ id: 'SectionsSpecialProducts.title' })}</h2>
      <div className={css.volumetricModularContent}>
        <div className={css.volumetricModularImg}>
          <p>{intl.formatMessage({ id: 'SectionsSpecialProducts.description1' })}</p>
          <img src={VolumetricModularImg} alt="" />
        </div>
        <div className={css.volumetricModularInfo}>
          <p>{intl.formatMessage({ id: 'SectionsSpecialProducts.description2' })}</p>
          <p>{intl.formatMessage({ id: 'SectionsSpecialProducts.description3' })}</p>
          <p>{intl.formatMessage({ id: 'SectionsSpecialProducts.description4' })}</p>
          <p>{intl.formatMessage({ id: 'SectionsSpecialProducts.description5' })}</p>
        </div>
      </div>
      <div className={css.fixedWidthContainer}>
        <div className={css.logPoints}>
          <ul>
            {[
              'list1',
              'list2',
              'list3',
              'list4',
              'list5',
              'list6',
              'list7',
            ].map((key, i) => (
              <li key={i}>
                <Icons name="checkListIcon" />
                {intl.formatMessage({ id: `SectionsSpecialProducts.${key}` })}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SectionsSpecialProducts;
